
export const ASSIGN_LOAD_NEXT = 'ASSIGN_LOAD_NEXT';
export const ASSIGN_LOADED_NEXT = 'ASSIGN_LOADED_NEXT';

export const ASSIGN_UPDATE_NEXT = 'ASSIGN_UPDATE_NEXT';
export const ASSIGN_UPDATED_NEXT = 'ASSIGN_UPDATED_NEXT';

export const NEXT_TASK_DONE = 'NEXT_TASK_DONE';
